/**
 * Traductions arabe (MSA) — concepteur EduFlow et panneaux associés.
 * Fusionné dans i18n-ar.ts via spread.
 */
export const arEduflowDesignerExtras: Record<string, string> = {
  'common.title': 'العنوان',
  'common.delete': 'حذف',
  'common.copied': 'تم النسخ!',
  'common.preview': 'معاينة',
  'common.save': 'حفظ',
  'common.publish': 'نشر',
  'common.search': 'بحث…',

  'eduflow.edit_flow': 'تعديل المسار',
  'eduflow.flow_name': 'اسم المسار',
  'eduflow.block_palette': 'لوحة الكتل',
  'eduflow.canvas': 'اللوحة',
  'eduflow.properties': 'الخصائص',
  'eduflow.publish': 'نشر',
  'eduflow.publish_confirm': 'هل تؤكدون نشر هذا المسار؟',
  'eduflow.save_draft': 'حفظ المسودة',
  'eduflow.preview': 'معاينة',
  'eduflow.versions': 'الإصدارات',
  'eduflow.add_block': 'إضافة كتلة',
  'eduflow.remove_block': 'حذف الكتلة',
  'eduflow.connect_blocks': 'ربط الكتل',
  'eduflow.undo': 'تراجع',
  'eduflow.redo': 'إعادة',
  'eduflow.zoom_in': 'تكبير',
  'eduflow.zoom_out': 'تصغير',
  'eduflow.fit_view': 'ملاءمة العرض',
  'eduflow.auto_layout': 'تخطيط تلقائي',
  'eduflow.unsaved_changes': 'تغييرات غير محفوظة',
  'eduflow.blocks.quiz_mcq': 'اختيار من متعدد',
  'eduflow.blocks.quiz_open': 'سؤال مفتوح',
  'eduflow.blocks.video': 'فيديو',
  'eduflow.blocks.audio': 'صوت',
  'eduflow.blocks.text': 'نص',
  'eduflow.blocks.evaluation': 'تقييم',
  'eduflow.blocks.form': 'نموذج',
  'eduflow.blocks.mindmap': 'خريطة ذهنية',
  'eduflow.blocks.poll': 'استطلاع',
  'eduflow.blocks.flashcard': 'بطاقة تعليمية',
  'eduflow.blocks.timeline': 'خط زمني',
  'eduflow.blocks.pdf': 'مستند PDF',
  'eduflow.blocks.image': 'صورة',
  'eduflow.blocks.code': 'شفرة',
  'eduflow.blocks.whiteboard': 'سبورة',
  'eduflow.blocks.ai_chat': 'محادثة ذكاء اصطناعي',
  'eduflow.blocks.certificate': 'شهادة',
  'eduflow.blocks.attendance': 'حضور',
  'eduflow.blocks.sortable': 'ترتيب',
  'eduflow.blocks.pair_matching': 'مواءمة أزواج',
  'eduflow.blocks.drawing': 'رسم',
  'eduflow.blocks.embed': 'محتوى مدمج',
  'eduflow.blocks.h5p': 'H5P',
  'eduflow.blocks.scorm': 'SCORM',
  'eduflow.blocks.conditional': 'شرط',
  'eduflow.blocks.timer': 'مؤقت',
  'eduflow.blocks.randomizer': 'عشوائي',
  'eduflow.blocks.grouping': 'تجميع',
  'eduflow.blocks.debate': 'نقاش',
  'eduflow.blocks.roleplay': 'لعب أدوار',
  'eduflow.blocks.simulation': 'محاكاة',
  'eduflow.blocks.scenario': 'سيناريو',
  'eduflow.blocks.checklist': 'قائمة تحقق',
  'eduflow.blocks.kanban': 'كانبان',
  'eduflow.blocks.peer_review': 'مراجعة الأقران',
  'eduflow.blocks.podcast': 'بودكاست',
  'eduflow.blocks.signature': 'توقيع',
  'eduflow.blocks.facial_recognition': 'التعرّف على الوجه',

  'eduflow.category.content': 'محتوى',
  'eduflow.category.assessment': 'تقييم',
  'eduflow.category.interactive': 'تفاعلي',
  'eduflow.category.forms': 'نماذج',
  'eduflow.category.flow': 'تحكّم بالمسار',
  'eduflow.category.advanced': 'متقدّم',
  'eduflow.category.other': 'أخرى',

  'eduflow.versionHistory': 'سجل الإصدارات',
  'eduflow.versionHistory.count': '{{count}} إصدارًا',
  'eduflow.versionHistory.create': 'إنشاء إصدار',
  'eduflow.versionHistory.createVersion': 'إنشاء {{version}}',
  'eduflow.versionHistory.minor': 'فرعي',
  'eduflow.versionHistory.major': 'رئيسي',
  'eduflow.versionHistory.minorBadge': 'إصدار فرعي',
  'eduflow.versionHistory.majorBadge': 'إصدار رئيسي',
  'eduflow.versionHistory.latest': 'الأحدث',
  'eduflow.versionHistory.public': 'إصدار عام',
  'eduflow.versionHistory.publicActive': 'نشط للمتعلّمين',
  'eduflow.versionHistory.publish': 'نشر هذا الإصدار',
  'eduflow.versionHistory.publishCta': 'نشر',
  'eduflow.versionHistory.openPublicPlayer': 'فتح المشغّل العام',
  'eduflow.versionHistory.copyPublicPlayer': 'نسخ الرابط العام',
  'eduflow.versionHistory.copyPublicPlayerError': 'تعذّر نسخ الرابط العام',
  'eduflow.versionHistory.systemPublished': 'نشر {{version}}',
  'eduflow.versionHistory.systemSaved': 'حفظ {{version}}',
  'eduflow.versionHistory.systemAutosaveRestore': 'حفظ تلقائي قبل استعادة {{version}}',
  'eduflow.versionHistory.descriptionPlaceholder': 'وصف التغييرات…',
  'eduflow.versionHistory.empty': 'لم يُنشأ أي إصدار.',
  'eduflow.versionHistory.emptyHint': 'احفظوا إصدارًا رئيسيًا أو فرعيًا ليعود ظاهرًا هنا.',
  'eduflow.versionHistory.blocks': '{{count}} كتلة',
  'eduflow.versionHistory.restoreTitle': 'تحميل {{label}} في المُصمّم؟',
  'eduflow.versionHistory.restoreWarning':
    'سيُستبدل مسودّة المُصمّم بهذا الإصدار (معرّفات كتل جديدة). إصدار المتعلّمين العام لا يتغيّر ما لم تعدّلوه لاحقًا.',
  'eduflow.versionHistory.createSuccess': 'تم إنشاء {{version}}',
  'eduflow.versionHistory.createError': 'تعذّر إنشاء الإصدار',
  'eduflow.versionHistory.restoreSuccess': 'تمت استعادة {{version}}',
  'eduflow.versionHistory.restoreError': 'تعذّر تحميل هذا الإصدار في المُصمّم',
  'eduflow.versionHistory.publishSuccess': 'تم نشر {{version}}',
  'eduflow.versionHistory.publishError': 'تعذّر نشر الإصدار',
  'eduflow.versionHistory.now': 'الآن',
  'eduflow.versionHistory.minutesAgo': 'منذ {{count}} دقيقة',
  'eduflow.versionHistory.hoursAgo': 'منذ {{count}} ساعة',
  'eduflow.versionHistory.yesterday': 'أمس',
  'eduflow.versionHistory.daysAgo': 'منذ {{count}} يومًا',
  'eduflow.versionHistory.activateSuccess': 'تم تفعيل {{label}} (عامّة)',
  'eduflow.versionHistory.activateTitle': 'جعل {{label}} عامّة؟',
  'eduflow.versionHistory.confirmActivate': 'جعلها عامّة',
  'eduflow.versionHistory.activateWarning':
    'يقرأ المتعلّمون (المشغّل العام والمسارات المُسنَدة) هذا الإصدار. مسودّة المُصمّم لا تتغيّر — استخدموا «تحميل في المُصمّم» للعودة إليه.',
  'eduflow.versionHistory.activateError': 'تعذّر التفعيل العلني',
  'eduflow.versionHistory.copyFailed': 'تعذّر النسخ',
  'eduflow.versionHistory.copyHtml': 'نسخ HTML',
  'eduflow.versionHistory.copyPlain': 'نسخ النص فقط',
  'eduflow.versionHistory.createMajor': 'إصدار رئيسي',
  'eduflow.versionHistory.createMajorSuccess': 'تم إنشاء الإصدار الرئيسي',
  'eduflow.versionHistory.createMinor': 'إصدار فرعي',
  'eduflow.versionHistory.createMinorSuccess': 'تم إنشاء الإصدار الفرعي',
  'eduflow.versionHistory.deleteError': 'تعذّر الحذف',
  'eduflow.versionHistory.deleteSuccess': 'تم حذف الإصدار',
  'eduflow.versionHistory.deleteTitle': 'حذف {{label}}؟',
  'eduflow.versionHistory.deleteWarning': 'هذا الإجراء نهائي.',
  'eduflow.versionHistory.duplicateConfirm': 'تكرار',
  'eduflow.versionHistory.duplicateError': 'تعذّر التكرار',
  'eduflow.versionHistory.duplicateMinor': 'تكرار (فرعي)',
  'eduflow.versionHistory.duplicateSuccess': 'تم تكرار الإصدار — استُعيد المحتوى في المُصمّم',
  'eduflow.versionHistory.duplicateTitle': 'تكرار {{label}}؟',
  'eduflow.versionHistory.duplicateHint': 'يُنشأ إصدار فرعي جديد وتُستعاد المحتويات في المُصمّم.',
  'eduflow.versionHistory.newFromCurrent': 'إصدار جديد من المحتوى الحالي',
  'eduflow.versionHistory.preview': 'معاينة',
  'eduflow.versionHistory.previewBlocks': '{{count}} كتلة',
  'eduflow.versionHistory.previewEdges': '{{count}} اتصال',
  'eduflow.versionHistory.previewError': 'تعذّر تحميل المعاينة',
  'eduflow.versionHistory.previewTitle': 'معاينة {{label}}',
  'eduflow.versionHistory.setPublic': 'جعلها عامّة',
  'eduflow.versionHistory.startDescModalTitle': 'الوصف — كتلة البداية ({{version}})',
  'eduflow.versionHistory.startDescModalHint': 'انسخوا المحتوى والصقوه في خصائص كتلة البداية عند الحاجة.',
  'eduflow.versionHistory.startBlockDescription': 'عرض/نسخ وصف كتلة البداية',
  'eduflow.versionHistory.restoreToDesigner': 'تحميل في المُصمّم',
  'eduflow.versionHistory.restoreShort': 'مُصمّم',
  'eduflow.versionHistory.confirmRestore': 'تحميل',

  'eduflow.unsaved': 'تغييرات غير محفوظة',
  'eduflow.flowSettings': 'إعدادات المسار',
  'eduflow.exportFlow': 'تصدير المسار',
  'eduflow.blocks': 'الكتل',
  'eduflow.duration': 'المدة (ثوانٍ)',
  'eduflow.typeConfig': 'إعدادات النوع',
  'eduflow.noExtraConfig': 'لا إعدادات إضافية لهذا النوع من الكتل.',

  'eduflow.adaptiveReplacement.assist': 'بمساعدة',
  'eduflow.adaptiveReplacement.auto': 'تلقائي',
  'eduflow.adaptiveReplacement.force': 'فرض نسخة اللعب المبسّطة لهذه الكتلة',
  'eduflow.adaptiveReplacement.manual': 'يدوي',
  'eduflow.adaptiveReplacement.mode': 'الوضع',
  'eduflow.adaptiveReplacement.title': 'استبدال تكيّفي',

  'eduflow.designer': 'مُصمّم EduFlow',
  'eduflow.designer.paletteCategory.structure': 'المسار والبنية',
  'eduflow.designer.paletteCategory.content': 'المحتوى والوسائط',
  'eduflow.designer.paletteCategory.interactive': 'أنشطة وتقييم',
  'eduflow.designer.paletteCategory.accessibility': 'إتاحة (DYS)',
  'eduflow.designer.paletteCategory.enterprise': 'امتثال ومتقدّم',
  'eduflow.designer.paletteCategory.institution': 'كتل المؤسسة',
  'eduflow.designer.blockLabel.start': 'بداية',
  'eduflow.designer.blockLabel.end': 'نهاية',
  'eduflow.designer.blockLabel.summary': 'ملخّص',
  'eduflow.designer.blockLabel.form': 'نموذج',
  'eduflow.designer.blockLabel.loop': 'حلقة',
  'eduflow.designer.blockLabel.merge': 'تجميع',
  'eduflow.designer.blockLabel.split': 'تفرّع',
  'eduflow.designer.blockLabel.subflow': 'مسار فرعي',
  'eduflow.designer.blockLabel.timer': 'مؤقت',
  'eduflow.designer.blockLabel.email': 'بريد تلقائي',
  'eduflow.designer.blockLabel.text': 'نص',
  'eduflow.designer.blockLabel.podcast': 'بودكاست',
  'eduflow.designer.blockLabel.video': 'فيديو',
  'eduflow.designer.blockLabel.image': 'صورة مُعلّقة',
  'eduflow.designer.blockLabel.pdf': 'مستند PDF',
  'eduflow.designer.blockLabel.browser': 'صفحة ويب مدمجة',
  'eduflow.designer.blockLabel.presentation': 'عرض شرائح',
  'eduflow.designer.blockLabel.timeline': 'خط زمني',
  'eduflow.designer.blockLabel.chart': 'مخطط تفاعلي',
  'eduflow.designer.blockLabel.mindmap': 'خريطة ذهنية',
  'eduflow.designer.blockLabel.visual_ai': 'صورة بالذكاء الاصطناعي',
  'eduflow.designer.blockLabel.quiz_mcq': 'اختبار (اختيار من متعدد / صحيح-خطأ / ترتيب)',
  'eduflow.designer.blockLabel.poll': 'استطلاع مباشر',
  'eduflow.designer.blockLabel.self_assessment': 'تقييم ذاتي',
  'eduflow.designer.blockLabel.evaluation': 'تقييم متعدد الأسئلة',
  'eduflow.designer.blockLabel.phrase_reveal': 'كشف تدريجي',
  'eduflow.designer.blockLabel.voice_assessment': 'تقييم صوتي',
  'eduflow.designer.blockLabel.dys_reader': 'قارئ DYS (مقاطع صوتية + TTS)',
  'eduflow.designer.blockLabel.dys_image_zones': 'مناطق تفاعلية على صورة',
  'eduflow.designer.blockLabel.dys_clock': 'ساعة ألوان DYS',
  'eduflow.designer.blockLabel.dys_reading_practice': 'تمارين قراءة مُكيّفة',
  'eduflow.designer.blockLabel.glossary': 'مسرد + اختبار مدمج',
  'eduflow.designer.blockLabel.html': 'HTML / JavaScript مخصّص',
  'eduflow.designer.blockLabel.certification': 'شهادة (قالب Word)',
  'eduflow.designer.blockLabel.signature': 'توقيع المتعلّم',
  'eduflow.designer.blockLabel.facial_recognition': 'التعرّف على الوجه',
  'eduflow.designer.blockLabel.attendance': 'حضور رقمي',
  'eduflow.designer.startBlockTitle': 'بداية',
  'eduflow.designer.placeholderUntitled': 'بلا عنوان',
  'eduflow.designer.placeholderFlowDescription': 'وصف الدورة (٢٥٥ حرفًا كحد أقصى)',
  'eduflow.designer.saving': 'جارٍ الحفظ…',
  'eduflow.designer.unsaved': 'غير محفوظ',
  'eduflow.designer.saved': 'محفوظ',
  'eduflow.designer.blocksPanelTitle': 'الكتل',
  'eduflow.designer.paletteSearchLabel': 'البحث عن كتلة',
  'eduflow.designer.paletteSearchPlaceholder': 'ابحث عن كتلة…',
  'eduflow.designer.paletteSearchEmpty': 'لا كتلة تطابق بحثكم.',
  'eduflow.designer.autoLayoutShort': 'تخطيط تلقائي',
  'eduflow.designer.validate': 'التحقّق',
  'eduflow.designer.validateTitle': 'التحقّق من المسار',
  'eduflow.designer.validationBeforePreview': 'صحّحوا أخطاء المسار قبل المعاينة.',
  'eduflow.designer.validationBeforePublish': 'صحّحوا أخطاء المسار قبل النشر.',
  'eduflow.designer.aiShort': 'ذكاء اصطناعي',
  'eduflow.designer.aiTitle': 'مساعد ذكاء اصطناعي',
  'eduflow.designer.ragChatbotTitle': 'روبوت محادثة الدورة',
  'eduflow.designer.aiPanel.welcome':
    'مرحبًا! أنا مساعد تصميم المسارات. صفوا الدورة المطلوبة لأقترح خطة؛ بعد موافقتكم أطبّق الكتل على اللوحة. الأهداف التربوية (بلوم، الكفاءات…) تُعرَض في لوحة «الأهداف التربوية» (أيقونة الهدف)، لا على اللوحة. يمكنكم طلب تعديلات بلغة طبيعية.',
  'eduflow.designer.aiPanel.quickActions': 'إجراءات سريعة',
  'eduflow.designer.aiPanel.placeholder': 'صفوا دورتكم أو اطلبوا تعديلًا على المسار…',
  'eduflow.designer.aiPanel.apply': 'تطبيق على اللوحة',
  'eduflow.designer.aiPanel.autoApply': 'تطبيق العمليات تلقائيًا على اللوحة',
  'eduflow.designer.aiPanel.autoApplyHint':
    'عند التفعيل، كل رد منظّم يحدّث المسار دون النقر على «تطبيق على اللوحة».',
  'eduflow.designer.aiPanel.dismissOps': 'تجاهل',
  'eduflow.designer.aiPanel.applied': 'تم تطبيق التعديلات على المسار.',
  'eduflow.designer.aiPanel.applyPartial': 'تُطبّق مع تحذيرات: {{details}}',
  'eduflow.designer.aiPanel.applyFailed': 'تعذّر تطبيق أي عملية على اللوحة (تنسيق العمليات أو أنواع كتل غير صالحة).',
  'eduflow.designer.aiPanel.objectivesSaved': 'تم حفظ الأهداف التربوية (لوحة الأهداف).',
  'eduflow.designer.aiPanel.objectivesSaveError': 'تعذّر حفظ الأهداف. أعيدوا المحاولة.',
  'eduflow.designer.aiPanel.error':
    'تعذّر الاتصال بالمساعد. تحقّقوا من إعدادات الذكاء الاصطناعي (مفتاح API) والشبكة.',
  'eduflow.designer.aiQuick.plan': 'اقتراح خطة للمسار',
  'eduflow.designer.aiQuick.expand': 'إثراء بكتل تفاعلية',
  'eduflow.designer.aiQuick.quiz': 'إضافة وحدة اختيار من متعدد',
  'eduflow.designer.aiQuick.objectives': 'تعبئة الأهداف (لوحة الأهداف)',
  'eduflow.designer.voiceShort': 'صوت',
  'eduflow.designer.voiceTitle': 'إعدادات الصوت',
  'eduflow.designer.objectivesShort': 'أهداف',
  'eduflow.designer.objectivesTitle': 'الأهداف التربوية',
  'eduflow.designer.onlineCount': '{{count}} متصل',
  'eduflow.designer.editingBlocks_one': 'كتلة واحدة قيد التحرير',
  'eduflow.designer.editingBlocks_other': '{{count}} كتل قيد التحرير',
  'eduflow.designer.invite': 'دعوة',
  'eduflow.designer.inviteTitle': 'دعوة متعاون',
  'eduflow.designer.exportTitle': 'تصدير المسار',
  'eduflow.designer.importTitle': 'استيراد مسار',
  'eduflow.designer.exportNeedSavedFlow': 'احفظوا الدورة قبل تصدير ملف .lyrra.',
  'eduflow.designer.canvasUntitled': 'بلا عنوان',
  'eduflow.designer.selectBlock': 'اختر كتلة',
  'eduflow.designer.selectBlockHint': 'انقروا كتلة على اللوحة لتعديل خصائصها',
  'eduflow.designer.blockPropertiesSubtitle': 'خصائص الكتلة',
  'eduflow.designer.blockTitleField': 'العنوان',
  'eduflow.designer.blockTitlePlaceholder': 'عنوان الكتلة',
  'eduflow.designer.newFlowDefaultTitle': 'دورة جديدة',
  'eduflow.designer.you': 'أنتم',
  'eduflow.designer.blockInfoPosition': 'المعرّف: {{id}} | الموقع: ({{x}}، {{y}})',
  'eduflow.designer.toastBlockCopied': 'تم نسخ الكتلة',
  'eduflow.designer.toastCollaboratorInvited': 'تمت دعوة المتعاون',
  'eduflow.designer.toastInviteError': 'تعذّر دعوة هذا المتعاون',
  'eduflow.designer.createFlowError': 'تعذّر إنشاء المسار',
  'eduflow.designer.loadFlowError': 'تعذّر تحميل هذه الدورة.',
  'eduflow.designer.loadFlowForbidden': 'ليس لديكم وصول إلى هذه الدورة.',
  'eduflow.designer.loadFlowNotFound': 'الدورة غير موجودة أو حُذفت.',
  'eduflow.designer.editConnection': 'تعديل الاتصال',
  'eduflow.designer.deleteConnection': 'حذف الاتصال',
  'eduflow.designer.autoLayoutDone': 'تم تطبيق التخطيط التلقائي',
  'eduflow.designer.autoLayoutFailed': 'تعذّر حساب التخطيط.',
  'eduflow.designer.autoLayoutNoBlocks': 'أضيفوا كتلة واحدة على الأقل لبدء التخطيط.',
  'eduflow.designer.lockedInstitutionBlock':
    'كتلة مؤسسة منشورة: يمكنكم وضعها ومراجعة الإعدادات، لكن لا يمكن تعديلها.',
  'eduflow.designer.toast.blockCopied': 'تم نسخ الكتلة',
  'eduflow.designer.toast.blockPasted': 'تم لصق الكتلة',
  'eduflow.designer.toast.blockDuplicated': 'تم تكرار الكتلة',
  'eduflow.designer.toast.connectionUpdated': 'تم تحديث الاتصال',
  'eduflow.designer.toast.flowExported': 'تم تصدير المسار',
  'eduflow.designer.toast.flowImported': 'تم استيراد المسار',
  'eduflow.designer.toast.invalidFile': 'ملف غير صالح',
  'eduflow.designer.toast.exportFailed': 'تعذّر التصدير.',
  'eduflow.designer.toast.importPackageFailed': 'تعذّر استيراد حزمة .lyrra.',
  'eduflow.designer.flowSettings.toolbarTitle': 'إعدادات الدورة والمشغّل',
  'eduflow.designer.flowSettings.panelTitle': 'إعدادات الدورة',
  'eduflow.designer.flowSettings.intro':
    'تُعرض في المشغّل (العنوان، الوصف، صورة الغلاف). يمكن إخفاء زر «السابق» لمسار تعلّم خطّي تمامًا.',
  'eduflow.designer.flowSettings.titleLabel': 'عنوان الدورة',
  'eduflow.designer.flowSettings.descriptionLabel': 'وصف الدورة',
  'eduflow.designer.flowSettings.coverLabel': 'صورة الغلاف',
  'eduflow.designer.flowSettings.coverUpload': 'رفع صورة',
  'eduflow.designer.flowSettings.coverUrlPlaceholder': 'أو الصق رابطًا لصورة (https://…)',
  'eduflow.designer.flowSettings.coverRemove': 'إزالة الغلاف',
  'eduflow.designer.flowSettings.allowPreviousLabel': 'زر «السابق» في المشغّل',
  'eduflow.designer.flowSettings.allowPreviousHint':
    'عند التعطيل لا يمكن للمتعلّم العودة إلى الكتلة السابقة (بما في ذلك اختصارات لوحة المفاتيح).',
  'eduflow.designer.untitled': 'بلا عنوان',
  'eduflow.designer.importedFlow': 'مسار مستورد',
  'eduflow.designer.collaborator.online': 'متصل',
  'eduflow.designer.collaborator.offline': 'غير متصل',
  'eduflow.designer.collaborator.defaultName': 'مستخدم',
  'eduflow.designer.collaborator.editor': 'محرّر',
  'eduflow.designer.collaborator.viewer': 'قارئ',
  'eduflow.designer.resizePanel': 'تغيير حجم اللوحة',
  'eduflow.designer.published': 'منشور',
  'eduflow.designer.draft': 'مسودة',
  'eduflow.designer.quizOutput.success': 'نجاح',
  'eduflow.designer.quizOutput.failure': 'فشل',
  'eduflow.designer.handle.default': 'افتراضي',
  'eduflow.designer.genError': 'خطأ أثناء التوليد. أعيدوا المحاولة.',

  'eduflow.summary.editorHint':
    'اذكروا المفاهيم أو الخطوات المعروضة في الدورة. كل سطر يظهر كبطاقة مرقّمة في المشغّل.',
  'eduflow.summary.addItem': 'إضافة نقطة',
  'eduflow.summary.emptyList': 'لا نقاط بعد. أضيفوا واحدة.',
  'eduflow.summary.itemPlaceholder': 'مثال: مخاطر الحريق في المؤسسة',

  'eduflow.selfAssessment.panelTitle': 'تقييم ذاتي',
  'eduflow.selfAssessment.panelHint':
    'عرّفوا بعدًا لتقييمه: عنوان قصير ووصف اختياري لتوجيه المتعلّم.',
  'eduflow.selfAssessment.scaleLabel': 'مقياس التنقيط',
  'eduflow.selfAssessment.scaleHint': 'من 1 إلى N (مثلاً 5 = ليكرت)',
  'eduflow.selfAssessment.criteriaSection': 'معايير',
  'eduflow.selfAssessment.addCriterion': 'إضافة',
  'eduflow.selfAssessment.emptyCriteria': 'لا معايير. أضيفوا سطرًا واحدًا على الأقل.',
  'eduflow.selfAssessment.criterionTitle': 'العنوان',
  'eduflow.selfAssessment.criterionTitlePh': 'مثال: التواصل، الاستقلالية…',
  'eduflow.selfAssessment.criterionDescription': 'وصف (اختياري)',
  'eduflow.selfAssessment.criterionDescriptionPh': 'وضّحوا ما يلاحظه المتعلّم أو كيف يقيم نفسه…',
  'eduflow.selfAssessment.moveUp': 'أعلى',
  'eduflow.selfAssessment.moveDown': 'أسفل',
  'eduflow.selfAssessment.removeCriterion': 'حذف هذا المعيار',
  'eduflow.selfAssessment.responseTypeLabel': 'نوع الإجابة',
  'eduflow.selfAssessment.typeNumeric': 'أرقام',
  'eduflow.selfAssessment.typeNumericHint': 'أزرار من 1 إلى N',
  'eduflow.selfAssessment.typeStars': 'نجوم',
  'eduflow.selfAssessment.typeStarsHint': 'تنقيط بصري',
  'eduflow.selfAssessment.typeText': 'نص حر',
  'eduflow.selfAssessment.typeTextHint': 'شارات (كلمات) أو نص حر لكل معيار',
  'eduflow.selfAssessment.badgeOptionsLabel': 'اقتراحات (شارات)',
  'eduflow.selfAssessment.badgeOptionsHint':
    'كلمات أو عبارات قصيرة يختارها المتعلّم كشارات. بلا اقتراحات → حقل نص حر.',
  'eduflow.selfAssessment.removeBadge': 'إزالة',
  'eduflow.selfAssessment.badgeInputPlaceholder': 'مثال: غالبًا، أبدًا، أحيانًا…',
  'eduflow.selfAssessment.addBadge': 'إضافة',
  'eduflow.selfAssessment.starCountLabel': 'عدد النجوم',
  'eduflow.selfAssessment.starCountHint': 'غالبًا 5',
  'eduflow.selfAssessment.textModeHint':
    'يكتب المتعلّم إجابة لكل معيار. التعليق العام يبقى أسفل المعايير في المشغّل.',

  'eduflow.ragChatbot.panelTitle': 'روبوت محادثة الدورة (RAG)',
  'eduflow.ragChatbot.loadError': 'تعذّر تحميل إعداد الروبوت.',
  'eduflow.ragChatbot.needDoc': 'أضيفوا مستندًا واحدًا على الأقل قبل تفعيل الروبوت.',
  'eduflow.ragChatbot.enabledOk': 'تم تفعيل الروبوت في المشغّل.',
  'eduflow.ragChatbot.disabledOk': 'تم إيقاف الروبوت.',
  'eduflow.ragChatbot.toggleError': 'تعذّر التحديث.',
  'eduflow.ragChatbot.uploadOk': 'فُهرس المستند.',
  'eduflow.ragChatbot.uploadError': 'فشل الرفع أو الفهرسة.',
  'eduflow.ragChatbot.confirmDelete': 'حذف هذا المستند وفهرسته؟',
  'eduflow.ragChatbot.deleted': 'تم حذف المستند.',
  'eduflow.ragChatbot.deleteError': 'تعذّر الحذف.',
  'eduflow.ragChatbot.vectorHint':
    'لفهرسة PDF / TXT / MD: اضبطوا DATABASE_VECTOR_URL أو PGVECTOR_HOST (PostgreSQL + امتداد pgvector) وMistral في الإدارة → تكاملات المنصة (مفتاح + نموذج تضمين). بدون ذلك يفشل الرفع والفهرسة.',
  'eduflow.ragChatbot.chatHint':
    'الردود والتضمينات RAG تستخدم Mistral. المستندات المضافة تُستشار عبر تضمينات Mistral وpgvector؛ بدون مستند، يُستخدم نص كتل المسار فقط كسياق.',
  'eduflow.ragChatbot.playerToggle': 'إظهار في المشغّل',
  'eduflow.ragChatbot.playerToggleHint':
    'يتساءل المتعلّمون عن محتوى هذه الدورة فقط: نص كتل المسار، ومقتطفات من المستندات المفهرسة إن وُجدت.',
  'eduflow.ragChatbot.addDocument': 'إضافة مستند (PDF، TXT، MD)',
  'eduflow.ragChatbot.docCount': 'مستندات مفهرسة: {{count}}',
  'eduflow.ragChatbot.emptyDocs': 'لا مستندات. يستخدم الروبوت نص كتل المسار فقط.',
  'eduflow.ragChatbot.open': 'فتح المساعد',
  'eduflow.ragChatbot.dialogTitle': 'مساعد الدورة',
  'eduflow.ragChatbot.playerDisclaimer': 'إجابات مبنية على مستندات هذه الدورة ومحتواها فقط.',
  'eduflow.ragChatbot.playerWelcome': 'اطرحوا سؤالًا عن الدرس أو المستندات المقدّمة.',
  'eduflow.ragChatbot.playerError': 'تعذّر الحصول على إجابة. أعيدوا المحاولة لاحقًا.',
  'eduflow.ragChatbot.placeholder': 'سؤالكم…',
  'eduflow.ragChatbot.send': 'إرسال',

  'eduflow.translation.toolbarTitle': 'ترجمة المحتوى',
  'eduflow.translation.toolbarShort': 'ترجمة',
  'eduflow.translation.title': 'ترجمة متعددة اللغات',
  'eduflow.translation.subtitle':
    'ترجموا نصوص الكتل (ذكاء اصطناعي) وأعيدوا توليد التعليق الصوتي للأوصاف عند الحاجة. تُحفظ النتائج لكل لغة.',
  'eduflow.translation.subtitleV2':
    'اختاروا صوت Mistral لكل لغة: تُستخدم للتعليق في المشغّل (ترجمة عند الطلب). مهام الترجمة أدناه اختيارية.',
  'eduflow.translation.voicesSection': 'أصوات TTS حسب اللغة',
  'eduflow.translation.voicesSectionHint':
    'معاينة باللغة المحدّدة. بلا صوت للفرنسية يُستخدم المحرّك «Marie - sad» افتراضيًا.',
  'eduflow.translation.voicesLangCount':
    '{{count}} لغات (FR، EN، ES، DE، IT، PT، LB، UK، RU، AR): اختر صوتًا ثم «استمعوا» لمقتطف قصير.',
  'eduflow.translation.voicesLoadError':
    'تعذّر تحميل الأصوات. تحقّقوا من الاتصال أو أعيدوا المحاولة.',
  'eduflow.translation.voicePreview': 'استمع',
  'eduflow.translation.previewStop': 'إيقاف',
  'eduflow.translation.voicePlaceholder': '— اختيار صوت —',
  'eduflow.translation.voiceSelectAria': 'صوت {{lang}}',
  'eduflow.translation.voicesSaveError': 'تعذّر حفظ الأصوات.',
  'eduflow.translation.selectVoiceFirst': 'اختاروا صوتًا لهذه اللغة.',
  'eduflow.translation.previewError': 'فشل تشغيل الصوت.',
  'eduflow.translation.batchSection': 'ترجمات مسبقة (اختياري)',
  'eduflow.translation.batchSectionHint':
    'يمكن للمشغّل الترجمة فورًا؛ شغّلوا مهمة فقط إن أردتم تثبيت النص والصوت مسبقًا في القاعدة.',
  'eduflow.translation.sourceLang': 'لغة المصدر للمسار',
  'eduflow.translation.bulkSection': 'كل اللغات',
  'eduflow.translation.includeText': 'نص',
  'eduflow.translation.includeAudio': 'صوت (تعليق وصفي)',
  'eduflow.translation.runAll': 'ترجمة كل اللغات (عدا المصدر)',
  'eduflow.translation.runAllHint': 'يُشغّل مهمة لكل لغة هدف من اللغات الـ12 المدعومة، باستثناء لغة المصدر.',
  'eduflow.translation.perLanguage': 'حسب اللغة',
  'eduflow.translation.sourceBadge': 'مصدر',
  'eduflow.translation.runOne': 'ترجمة',
  'eduflow.translation.history': 'مهام حديثة',
  'eduflow.translation.noHistory': 'لا مهام بعد.',
  'eduflow.translation.saveFirst': 'احفظوا المسار قبل تشغيل الترجمة.',
  'eduflow.translation.jobStarted': 'بُدئت الترجمة نحو {{lang}}.',
  'eduflow.translation.jobError': 'تعذّر بدء الترجمة.',
  'eduflow.translation.bulkStarted': 'بُدئت {{count}} ترجمة.',
  'eduflow.translation.bulkNone':
    'لا مهام جديدة: ترجمات قيد التنفيذ لكل الأهداف، أو الخيارات فارغة.',
  'eduflow.translation.bulkError': 'تعذّر بدء الترجمات المجمّعة.',
  'eduflow.translation.statusPending': 'قيد الانتظار',
  'eduflow.translation.statusProcessing': 'قيد التنفيذ',
  'eduflow.translation.statusCompleted': 'مكتمل',
  'eduflow.translation.statusFailed': 'فشل',
  'eduflow.translation.missingSourceAudioHint':
    'للترجمة مع الصوت: ولّدوا التعليق الصوتي أولًا (لغة {{lang}}) لكل وصف طويل. الكتل المعنية ({{count}}): {{blocks}}.',
  'eduflow.translation.missingSourceAudioToast':
    '{{count}} كتلة بلا تعليق صوتي بلغة المسار: {{blocks}}. ولّدوا الصوت من خصائص الكتلة ثم أعيدوا المحاولة.',

  'designer.ctx.addBlock': 'إضافة كتلة',
  'designer.ctx.blockInfo': 'معلومات الكتلة',
  'designer.ctx.changeColor': 'تغيير اللون',
  'designer.ctx.copy': 'نسخ',
  'designer.ctx.delete': 'حذف',
  'designer.ctx.duplicate': 'تكرار',
  'designer.ctx.edit': 'تعديل',
  'designer.ctx.fitView': 'ملاءمة العرض',
  'designer.ctx.lock': 'قفل',
  'designer.ctx.paste': 'لصق',
  'designer.ctx.toggleGrid': 'شبكة تشغيل/إيقاف',
  'designer.ctx.toggleMinimap': 'خريطة مصغّرة تشغيل/إيقاف',
  'designer.ctx.unlock': 'فتح القفل',
  'designer.edge.cancel': 'إلغاء',
  'designer.edge.color': 'اللون',
  'designer.edge.name': 'الاسم',
  'designer.edge.namePlaceholder': 'مثال: نجاح، فرع أ…',
  'designer.edge.save': 'حفظ',
  'designer.edge.title': 'اتصال',

  'designer.gamification.title': 'تلعيب',
  'designer.gamification.enable': 'تفعيل التلعيب',
  'designer.gamification.points': 'نقاط',
  'designer.gamification.pointsPerBlock': 'نقاط لكل كتلة مكتملة',
  'designer.gamification.bonusPerfect': 'مكافأة الدرجة الكاملة (اختبار)',
  'designer.gamification.timeBonus': 'مكافأة السرعة',
  'designer.gamification.pointsPerSecond': 'نقاط لكل ثانية مكسوبة',
  'designer.gamification.badges': 'شارات',
  'designer.gamification.noBadges': 'لا شارات معرّفة',
  'designer.gamification.badgeName': 'اسم الشارة',
  'designer.gamification.description': 'الوصف',
  'designer.gamification.icon': 'أيقونة',
  'designer.gamification.condition': 'شرط',
  'designer.gamification.conditionPlaceholder': 'مثال: quiz_completed >= 3',
  'designer.gamification.scoreGte': 'درجة ≥',
  'designer.gamification.blocksGte': 'كتل ≥',
  'designer.gamification.leaderboard': 'لوحة المتصدرين',
  'designer.gamification.enableLeaderboard': 'تفعيل التصنيف',
  'designer.gamification.topN': 'عرض أفضل N',
  'designer.gamification.publicLeaderboard': 'تصنيف علني',
  'designer.gamification.missions': 'مهام',
  'designer.gamification.noMissions': 'لا مهام معرّفة',
  'designer.gamification.missionTitle': 'عنوان المهمة',
  'designer.gamification.missionDesc': 'وصف (مثال: إكمال 3 اختبارات)',
  'designer.gamification.reward': 'مكافأة',

  'designer.objectives.title': 'الأهداف التربوية',
  'designer.objectives.add': 'إضافة',
  'designer.objectives.addTitle': 'إضافة هدف',
  'designer.objectives.cancel': 'إلغاء',
  'designer.objectives.category': 'الفئة',
  'designer.objectives.completed': 'مكتمل',
  'designer.objectives.empty': 'لا أهداف معرّفة.',
  'designer.objectives.emptyHint': 'أضيفوا أهدافكم التربوية الأولى.',
  'designer.objectives.errorToast': 'خطأ أثناء الحفظ',
  'designer.objectives.level': 'المستوى (بلوم)',
  'designer.objectives.linkedBlocks': 'كتل مرتبطة',
  'designer.objectives.noContentBlocks': 'لا كتل محتوى متاحة.',
  'designer.objectives.required': 'إلزامي',
  'designer.objectives.save': 'حفظ',
  'designer.objectives.savedToast': 'تم حفظ الأهداف',
  'designer.objectives.scoreGte': 'درجة ≥',
  'designer.objectives.update': 'تحديث',
  'designer.objectives.placeholder': 'سيكون المتعلّم قادرًا على…',
  'designer.objectives.defined_one': 'هدف معرّف واحد',
  'designer.objectives.defined_other': '{{count}} أهداف معرّفة',

  'designer.validation.title': 'التحقّق',
  'designer.validation.noStart': 'يجب أن تكون كتلة بداية واحدة بالضبط (لم يُعثر على أيّة).',
  'designer.validation.multipleStart': 'عدة كتل بداية ({{count}}): يُسمح بواحدة فقط.',
  'designer.validation.duplicateStart': 'كتلة بداية مكرّرة',
  'designer.validation.noEnd': 'لا كتلة نهاية. يجب وجود واحدة على الأقل.',
  'designer.validation.titleRequired': 'كتلة «{{type}}» يجب أن يكون لها عنوان.',
  'designer.validation.noOutgoing': 'كتلة «{{type}}» بلا اتصال صادر نحو كتلة تالية.',
  'designer.validation.tooManyOutputs': '«{{label}}»: اتصالات صادرة كثيرة ({{count}}، الحد الأقصى {{max}}).',
  'designer.validation.deadEndBranch': 'فرع بلا مسار نحو كتلة نهاية (من «{{label}}»).',
  'designer.validation.moreDeadEnds': '… و{{count}} فرع(وفروع) أخرى بلا مخرج نحو النهاية.',
  'designer.validation.noConvergence': 'الفروع من «{{label}}» لا تلتقي في كتلة مشتركة.',
  'designer.validation.orphanBlock': 'كتلة معزولة عن المخطط الرئيسي: «{{title}}».',
  'designer.validation.endHasOutgoing': 'كتلة النهاية «{{title}}» ما زال لها اتصال صادر.',
  'designer.validation.noScoring': 'إعدادات النقاط غير معرّفة لـ «{{title}}».',
  'designer.validation.emptyText': 'كتلة النص «{{title}}» فارغة.',
  'designer.validation.circularPath': 'مسار دائري مُكتشف',
  'designer.validation.summary': 'المسار: {{blocks}} كتلة، {{edges}} ربط.',
  'designer.validation.textTooLong':
    'كتلة النص «{{title}}» تُقدّر بـ {{lines}} سطرًا. الموصى به: من {{min}} إلى {{max}} سطرًا.',
  'designer.validation.splitTextBlock': 'تقسيم',
  'designer.validation.textSplitNotNeeded': 'هذه الكتلة لا تتجاوز حد القراءة الموصى به.',
  'designer.validation.textSplitUnable':
    'تعذّر اقتراح تقسيم تلقائي موثوق لهذه الكتلة.',
  'designer.validation.textSplitComplexFlow':
    'التقسيم التلقائي غير متاح لهذه الكتلة (تفرعات متعددة/شرطية).',
  'designer.validation.textSplitDone': 'تم إنشاء {{count}} كتل نصية',
  'designer.validation.textSplitConfirmTitle': 'هل تريد تقسيم كتلة النص هذه تلقائيًا؟',
  'designer.validation.textSplitConfirmMessage':
    'تُقدّر الكتلة «{{title}}» بـ {{lines}} سطرًا. سنقسمها إلى {{parts}} كتل (بالاعتماد على علامات الترقيم) ونضعها أسفل الكتلة الحالية بالترتيب.',
  'designer.validation.textSplitConfirmAction': 'تقسيم الكتلة',
  'designer.validation.invalid': 'غير صالح',
  'designer.validation.valid': 'صالح',
  'designer.validation.errorCount': '{{count}} خطأ',
  'designer.validation.warningCount': '{{count}} تحذير',
  'designer.validation.noIssues': 'لم يُعثر على مشاكل',
  'designer.validation.untitled': 'بلا عنوان',

  'designer.variables.title': 'متغيّرات',
  'designer.variables.system': 'متغيّرات النظام',
  'designer.variables.systemHint': 'قراءة فقط — متوفّرة في كل الكتل',
  'designer.variables.custom': 'متغيّرات مخصّصة',
  'designer.variables.noCustom': 'لا متغيّرات مخصّصة',
  'designer.variables.camelCaseError': 'الاسم يجب أن يكون camelCase (مثال: myVariable)',
  'designer.variables.type': 'النوع',
  'designer.variables.defaultValue': 'القيمة الافتراضية',
  'designer.variables.copy': 'نسخ',
  'designer.variables.howToTitle': 'كيفية استخدام المتغيّرات:',

  'voicePanel.title': 'الصوت الافتراضي',
  'voicePanel.provider': 'المزوّد: Mistral AI',
  'voicePanel.hint': 'اختاروا الصوت المستخدم للتعليق في الكتل.',
  'voicePanel.multiLangHint': 'لصوت Mistral لكل لغة (لغات الواجهة الـ12) افتحوا لوحة الترجمة (أيقونة اللغات في شريط المُصمّم).',
  'voicePanel.translationFrenchFallback': 'الصوت المترجم: بلا صوت افتراضي محفوظ هنا يُستخدم صوت «Marie - sad» (Mistral) للفرنسية.',
  'voicePanel.search': 'بحث…',
  'voicePanel.allLanguages': 'كل اللغات',
  'voicePanel.loading': 'جارٍ تحميل الأصوات…',
  'voicePanel.loadError': 'تعذّر تحميل الأصوات',
  'voicePanel.empty': 'لا أصوات متاحة.',
  'voicePanel.emptyHint': 'تحقّقوا من مفتاح Mistral في الإدارة → التكاملات.',
  'voicePanel.noResults': 'لا أصوات تطابق بحثكم.',
  'voicePanel.saved': 'تم حفظ الصوت الافتراضي',
  'voicePanel.saveError': 'خطأ أثناء الحفظ',
  'voicePanel.default': 'افتراضي',
  'voicePanel.female': 'أنثى',
  'voicePanel.male': 'ذكر',
  'voicePanel.playPreview': 'تجربة الصوت',
  'voicePanel.stopPreview': 'إيقاف',
  'voicePanel.noPreview': 'المعاينة غير متاحة',
  'voicePanel.previewLoading': 'جارٍ التوليد…',
  'voicePanel.previewGenerateError': 'تعذّر توليد معاينة الصوت.',
  'voicePanel.previewPlayError': 'فشل تشغيل الصوت.',
  'voicePanel.filterNoVoicesForLang': 'لا صوت في الفهرس لهذه اللغة — جرّبوا «كل اللغات».',
};
